import React, {useEffect, useState} from 'react'
import {CountResult, searchCounts} from '../../utils'
import {DataGrid, GridColDef} from '@mui/x-data-grid'
import Button from '@mui/material/Button'

interface CountsTableProps {
    countClosed: boolean
    confirmClose: (countId: number) => void
}

const CountsTable = ({
                         countClosed,
                         confirmClose
                     }: CountsTableProps) => {
    const [counts, setCounts] = useState<CountResult[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const loadCounts = async () => {
            try {
                const data = await searchCounts({
                    iteration_statuses: 'pending,in-progress,in-review',
                    page_size: '200'
                })

                setCounts(data)
            } catch (error) {
                console.error('Failed to fetch counts', error)
            } finally {
                setLoading(false)
            }
        }

        loadCounts()
    }, [countClosed])

    const columns: GridColDef[] = [
        {field: 'count_id', headerName: 'Count', width: 115},
        {field: 'location_id', headerName: 'Truck', width: 115},
        {field: 'type', headerName: 'Type', width: 115},
        {field: 'iteration', headerName: 'Iteration', width: 130},
        {field: 'iteration_status', headerName: 'Status', width: 180},
        {field: 'requested_by', headerName: 'Requester', width: 180},
        {
            field: 'requested_at',
            headerName: 'Requested',
            width: 200,
            renderCell: (params) => new Date(params.row.requested_at).toLocaleString()
        },
        {
            field: 'started_at',
            headerName: 'Started',
            width: 200,
            valueGetter: (params) => {
                return params !== 'N/A' ? new Date(params).getTime() : null // For sorting
            },
            renderCell: (params) => params.row.started_at !== 'N/A' && new Date(params.row.started_at).toLocaleString()
        },
        {field: 'assigned_to', headerName: 'Assigned', width: 180},
        {
            field: 'action',
            headerName: 'Action',
            width: 180,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => confirmClose(params.row.count_id)}
                >
                    Close Count
                </Button>
            )
        }
    ]

    const rows = counts.map((c: CountResult) => ({
        id: c.countId,
        count_id: c.countId,
        location_id: c.locationId,
        type: c.type,
        iteration: c.iteration.iterationId,
        iteration_status: c.iteration.status,
        requested_by: c.requestedBy,
        requested_at: c.requestedAt,
        started_at: c.iteration.assignedAt ?? 'N/A',
        assigned_to: c.iteration.assignedTo,
    }))

    return (
        <div style={{height: 600, width: '100%', backgroundColor: 'whitesmoke'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                disableRowSelectionOnClick
            />
        </div>
    )
}

export default CountsTable
